export default {
    message: {
        tiers: {
            t1: {
                label: "Prodotto indipendente",
                desc: "<p>Accesso unificato a tutte le applicazioni virtuali, web e SaaS. Protegge gli utenti, le applicazioni e i dati con controlli di sicurezza contestuali end-to-end.</p><p>Fornisce proxy senza VPN e SSO per le applicazioni web, SaaS, virtuali e mobili, oltre alla protezione da contenuti dannosi, keylogger e malware che cattura schermate.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>Soluzione di workspace completa per i lavoratori che necessitano di un workspace totalmente digitale dotato di sicurezza granulare, ma che non richiedono applicazioni e desktop virtuali.</p><p>Include le funzionalità di Workspace Standard, oltre ai controlli di sicurezza avanzati per SaaS e web, unified endpoint management e Content Collaboration Premium.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Una soluzione di workspace completa che comprende opzioni di distribuzione ibrida per Citrix Virtual Apps and Desktops.</p><p>Include le funzionalità di Workspace Premium, oltre a un’opzione di gestione del cloud per Citrix Virtual Apps and Desktops.</p>"
            }
        }
    }
}